import React from 'react';
import { Spinner } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { OfficeAdminsTab } from './components/tabs';
import { OrgStructureTab } from './components/tabs/OrgStructureTab';
import { useDsoGroupDetails } from './hooks/useDsoGroupDetails';
import { getTabByName } from './utils';
import { JobsTab } from './components/tabs/JobsTab/JobsTab';

export const DsoGroupDetails = () => {
  const params = useParams();
  const selectedTab = getTabByName(params?.currentTab);
  const {
    isLoading,
    data: dsoGroupDetails,
    handleTabSelection,
  } = useDsoGroupDetails(params?.id, selectedTab);

  if (!params?.id || isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          marginTop: 200,
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spinner
          animation="border"
          role="status"
          variant="info"
          style={{
            height: 30,
            width: 30,
          }}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: 'calc(100vh - 102px)',
        overflowY: 'scroll',
        overflowX: 'auto',
      }}
      className="bg-light"
    >
      <div
        className="card bg-light"
        style={{
          width: '100%',
          minWidth: '1460px',
          display: 'flex',
          justifyContent: 'center',
          border: 0,
        }}
      >
        <div
          className="card-body"
          style={{
            backgroundColor: '#435963',
            width: '100%',
            minHeight: '125px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: '90%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <h2
                className="card-title"
                style={{
                  position: 'relative',
                  margin: '0px',
                  color: 'white',
                  fontWeight: 400,
                }}
              >
                {dsoGroupDetails.name}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          width: '100%',
          minWidth: '1460px',
          justifyContent: 'center',
          backgroundColor: '#FAFAFA',
          margin: 0,
          marginBottom: 30,
        }}
      >
        <div
          style={{
            height: '100%',
            maxHeight: '960px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              marginTop: '10px',
              position: 'relative',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            {['Org Structure', 'Office Staffs', 'Jobs'].map((tab) => (
              <button
                type="button"
                className="btn btn-info mr-1 ml-1"
                style={{
                  backgroundColor: selectedTab === tab ? '#4FC0CF' : '#307F92',
                  border: 'none',
                }}
                onClick={() => handleTabSelection(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div
            style={{
              position: 'relative',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {selectedTab === 'Org Structure' && <OrgStructureTab />}
            {selectedTab === 'Office Staffs' && <OfficeAdminsTab />}
            {selectedTab === 'Jobs' && <JobsTab />}
          </div>
        </div>
      </div>
    </div>
  );
};
